import { Form, FormikProps, useFormikContext } from 'formik'
import React, { useState } from 'react'
import CodeInput from 'src/components/Fields/CodeInput'
import Input from 'src/components/Fields/Input'
import { MandatManagerStatus } from 'src/constants/status'
import { sendOtpCode } from 'src/services/authMandat'
import { getCustomerByNumClient, sendNewInfo } from 'src/services/customer'
import request from 'superagent'

export interface AuthByCodeFields {
  identifiant: string
  email: string
  code: (number | null)[]
}

interface AuthByCodeFormProps extends FormikProps<AuthByCodeFields> {}

const AuthByCodeForm: React.FC<AuthByCodeFormProps> = () => {
  const [showCodeInput, setShowCodeInput] = useState(false)
  const [messageError, setErrorMessage] = useState('')

  const form = useFormikContext<AuthByCodeFields>()

  const idValidate = async () => {
    if (form.isValid) {
      try {
        const response = await sendOtpCode({ clientId: form.values.identifiant, email: form.values.email })

        if (response) {
          setShowCodeInput(true)
          setErrorMessage('')
        }
      } catch (error) {
        setErrorMessage('Une erreur est survenue.')
      }
    }
  }

  const onConfirm = async () => {
    const numClient = form.values.identifiant;
    let clientId = null;
    try {
      if (!numClient) return;
      const response = await getCustomerByNumClient(numClient);
      const client = response?.data?.[0];
      clientId = client.id
    } catch (error) {
      console.error("Erreur lors de la récupération de l'id client", error)
      setErrorMessage('Une erreur est survenue, veuillez recommencer')
      return;
    }

    try {
      if (!clientId) return
      const payload = {
        status: MandatManagerStatus.EN_COURS
      }
      await sendNewInfo(clientId, payload);
      form.submitForm()
    } catch (error) {
      console.error("Erreur lors de la mise à jours du status", error)
      setErrorMessage('Une erreur est survenue, veuillez recommencer')
      return;
    }
  }

  return (
    <Form
      className="w-full"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        border: 'solid 1px #f4f4f4',
        marginBottom: '15px',
        backgroundColor: '#f9fafb',
        paddingBottom: '30px',
        borderRadius: '10px',
        marginTop: '25px',
      }}
    >
      {!showCodeInput ? (
        <>
          <div style={{ flexDirection: 'column', alignItems: 'center', width: '90%' }} id="inscription">
            <h2>Veuillez renseigner votre numéro de compte client</h2>
            <Input
              name="identifiant"
              label="Numéro de compte client"
              placeholder="Numéro de compte client"
              maxLength={7}
              style={{ width: '350px', backgroundColor: 'white' }}
              required
            />
            <Input
              name="email"
              label="Email"
              placeholder="Votre email"
              style={{ width: '350px', backgroundColor: 'white' }}
              required
            />
            {messageError && <div style={{ color: 'rgb(210, 38, 48)' }}>{messageError}</div>}
          </div>
          <button
            style={{ width: '260px' }}
            className="cta my-2 flex-grow-0"
            type="button"
            disabled={!(form.isValid && form.dirty)}
            onClick={idValidate}
          >
            Valider
          </button>
        </>
      ) : (
        <>
         <CodeInput duration={5}  onConfirm={onConfirm}/>
          {messageError && <div style={{ color: 'rgb(210, 38, 48)' }}>{messageError}</div>}
        </>
      )}
    </Form>
  )
}

export default AuthByCodeForm
